import React, {PureComponent} from "react"
import {get} from "lodash"

import {Deal, Product, BasketItemType} from "@irati/types"
import {Body, H1} from "@irati/ui/src/Typography"
import Form from "@irati/ui/src/Form"
import {FormattedMessage} from "@irati/utils/lang"
import idHelper from "@irati/utils/id"

import {formatCurrency} from "@irati/utils/currency/formatCurrency"
import getDealCurrency from "@irati/deals/helpers/deals/currency"
import {OverlayPlacement} from "@irati/ui/src/Tooltip/Overlay"

import basket from "@irati/checkout/utils/basket"
import OpenValueInput from "./shared/Quantity/OpenValueInput"
import StyledTooltip from "./shared/styled/Tooltip"

interface Props {
  deal: Deal,
  products: Product[]
}

class OpenValueProduct extends PureComponent<Props> {
  handleOpenValueChange = (productId: string, value: string) => {
    if (value) {
      const openValue = Math.round(parseFloat(value) * 100)
      basket.setProduct(BasketItemType.Deal, this.props.deal.uuid, productId, {openValue, count: 1})
    } else {
      basket.clear()
    }
  }

  render() {
    const {deal, products} = this.props

    const minValue = get(deal, "productConfig.limits.forOpenValue.minValue")
    const maxValue = get(deal, "productConfig.limits.forOpenValue.maxValue")

    return (
      <div>
        <H1>
          <FormattedMessage id="perks.productForms.openValueProduct.header" />
        </H1>
        <Body margin={[2, 0, 4]} width="80%">
          <FormattedMessage id="perks.productForms.openValueProduct.desc" />
        </Body>
        <Form>
          <div>
            <Body weight="bold" marginBottom={1}>
              <FormattedMessage id="perks.productForms.openValueProduct.voucherAmount.para" />
            </Body>
            <Body>
              <FormattedMessage
                id="perks.productForms.openValueProduct.minMax.label"
                values={{
                  minValue: formatCurrency({
                    currencyCode: getDealCurrency(deal),
                    isCents: false,
                    value: minValue,
                    trimZerosFromWholeNumber: true
                  }),
                  maxValue: formatCurrency({
                    currencyCode: getDealCurrency(deal),
                    isCents: false,
                    value: maxValue,
                    trimZerosFromWholeNumber: true
                  })
                }} />
              <StyledTooltip icon="i" placement={OverlayPlacement.Top}>
                <Body small weight="semibold">
                  <FormattedMessage id="perks.productForms.openValueProduct.tooltip.title" />
                </Body>
                <Body small padding={[1, 0]}>
                  <FormattedMessage id="perks.productForms.openValueProduct.tooltip.description" />
                </Body>
              </StyledTooltip>
            </Body>
            {products.map((item: Product) => (
              <OpenValueInput
                key={item.uuid}
                minValue={minValue}
                maxValue={maxValue}
                product={item}
                handleChange={this.handleOpenValueChange}
                id={idHelper(item.name, this.props)} />
            ))}
          </div>
        </Form>
      </div>
    )
  }
}

export default OpenValueProduct
